import { Colors, FInter, FlexBox, Fonts } from "@brg/ui";
import { TableCell } from "@tiptap/extension-table";
import { CoreContainer, LayoutConst } from "core";
import { SectionContent } from "shared/components/legals/styles";
import styled, { css } from "styled-components";
import { EditorContent } from "@tiptap/react";

const FOOTER_HEIGHT = 40;

export const StyledEditorContent = styled(EditorContent)`
  .ProseMirror {
    min-height: 180px;
    height: 800px;
    border: 1px solid ${(p) => p.theme.legals.textColor};
    padding: 5px;
    margin: 10px 0;
    border-radius: 3px;
    overflow-y: scroll;
    overflow-x: hidden;

    td {
      position: relative;
    }
    
    .column-resize-handle {
      position: absolute;
      top: 0;
      right: -2px;
      bottom: 0;
      width: 4px; 
      background: transparent;
      z-index: 10;
      cursor: col-resize !important;
    }
  
    .column-resize-handle:hover {
      background: rgba(0, 0, 0, 0.1);
    }
  }
`;

export const CustomTableCell = TableCell.extend({
  addAttributes() {
    return {
      ...this.parent?.(),

      borderStyle: {
        default: "2px solid #ced4da",
        parseHTML: (element) => element.style.borderStyle || "2px solid #ced4da",
        renderHTML: (attributes) => {
          return {
            style: `border: ${attributes.borderStyle}`,
          };
        },
      },
      backgroundColor: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-background-color"),
        renderHTML: (attributes) => {
          return {
            "data-background-color": attributes.backgroundColor,
            style: `background-color: ${attributes.backgroundColor}`,
          };
        },
      },
      style: {
        default: "height: 28px; padding: 3px 5px",
      },
    };
  },
});

export const LegalBlocks = styled.div`
  max-width: 890px;
  margin: 20px 0 60px 400px;
  color: ${(p) => p.theme.legals.textColor};
  @media (max-width: ${LayoutConst.screen.md}px) {
    margin-left: 0;
    padding: 40px 10px;
    ${SectionContent} {
      margin-left: 0;
    }
  }
`;

export const Routes = styled.div`
  width: 100%;
  font-size: 13.4px;
  line-height: 1.27em;
  margin-bottom: 60px;

  span:first-of-type {
    margin-right: 10px;
  }
`;

export const Tab = styled.div`
  position: sticky;
  top: 52px;
  width: 360px;
  box-sizing: border-box;
  height: max-content;
  align-self: flex-start;
  left: 20px;
  margin-right: 32px;
  margin-bottom: 32px;
  color: ${(p) => p.theme.legals.textColor};
  flex-shrink: 0;
  @media (max-width: ${LayoutConst.screen.md}px) {
    width: 220px;
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    width: 100%;
    border: none;
    position: static;
    height: min-content;
    z-index: 2;
    top: 48px;
    margin-right: 24px;
  }
`;
export const Arrow = styled.span`
  border-right: 2px solid;
  border-bottom: 2px solid;
  position: relative;
  bottom: 2px;
  display: inline-block;
  padding: 3px;
  transform: rotate(-45deg);
  margin-right: 10px;
  border-color: ${(p) => p.theme.legals.textColor};
`;

export const AdminPageDocumentList = styled(FlexBox)`
  width: 100%;
  flex-flow: column;
  margin: 0 auto;
  justify-content: center;
  place-items: center;
  background: #fff;
  padding: 24px 48px;
  max-width: 1152px;
`;

export const EditButtonWrapper = styled(FlexBox)`
  position: absolute;
  right: 0px;
  top: 0px;
`;

export const ArrowDown = styled(FlexBox) <{ isOpen: boolean }>`
  margin: 7px;
  transition: transform 0.2s;
  cursor: pointer;

  svg path {
    fill: #909090;
  }

  ${({ isOpen }) =>
    isOpen &&
    css`
      transform: rotate(180deg);
      transition: transform 0.2s;
    `};
`;

export const DeleteBtnWrapper = styled(FlexBox)`
  cursor: pointer;
  svg {
    overflow: visible;
  }
`;

export const AdminPageDocument = styled.div<{ isDraggable?: boolean }>`
  color: ${({ theme }) => theme.projectEdit.label};
  font-family: Inter;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.3px;

  ${({ isDraggable }) => isDraggable && css`
    display: flex;
    justify-content: space-between;
    place-items: center;

    // .divider {
    //   // margin-right: 16px;
    // }
  `};
`;

export const AdminEditContainer = styled(FlexBox)`
  justify-content: space-between;
  display: flex;
  margin-top: 60px;
  margin: 0 auto;
  flex-direction: column;
  width: 954px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 710px;
  }

  .white_theme_project_underline {
    font-size: 23px;
    line-height: 29px;

    @media (max-width: ${LayoutConst.screen.md}px) {
      font-size: 20px;
      line-height: 25px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      font-size: 15px;
      line-height: 20px;
    }
  }
`;

export const AdminScrollEditContainer = styled(AdminEditContainer)`
  margin: 0 auto ${FOOTER_HEIGHT}px auto;
`;

export const AdminInputGrid = styled(FlexBox) <{ marginTop?: number }>`
  flex-direction: column;

  ${({ marginTop }) =>
    marginTop
      ? css`
          margin-top: ${marginTop}px;
        `
      : null};
`;

export const AvailableAppsContainer = styled(FlexBox)`
  flex-direction: row;
  margin-top: 20px;
  flex-wrap: wrap;
  display: flex;
`;

export const SiteContextItem = styled(FlexBox) <{ isActive: boolean; isClickable: boolean }>`
  border: 1px solid;
  border-color: ${({ theme }) => theme.projectEdit.label};
  color: ${({ theme }) => theme.projectEdit.label};
  border-radius: 3px;
  margin: 5px;
  padding: 3px 7px;
  font-size: 13px;
  line-height: 18px;

  ${({ isClickable }) =>
    isClickable &&
    css`
      cursor: pointer;
    `};

  ${({ isActive }) =>
    isActive &&
    css`
      background-color: ${({ theme }) => theme.projectEdit.label};
      color: white;
    `};
`;

export const LegalDocumentAdminRow = styled(FlexBox) <{ gradientNeed?: boolean; blackBG?: boolean }>`
  position: relative;
  align-items: center;

  & + & {
    margin-top: 24px;
  }

  &:after {
    content: "";
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 2px;
    width: 97px;
    z-index: 2;
    height: 45px;
    background: ${(p) =>
    p?.blackBG
      ? "linear-gradient(270deg, rgba(197,198,199,0.9) 55% , rgba(197,198,199,0) 100%);"
      : "linear-gradient(270deg, rgba(242,242,242,0.9) 55.21%, rgba(242, 242, 242, 0) 100%);"};
    display: ${(p) => (p?.gradientNeed ? "inline-block" : "none")};
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    height: auto;
    & + & {
      margin-top: 16px;
    }
  }
`;

export const LegalDocumentsTitle = styled(FInter.MainTitleMedium) <{ fontSize: string }>`
  margin-top: 56px;
  font-weight: 600;
  padding-bottom: 11px;

  line-height: 70px;
  white-space: pre;
  color: ${(p) => p.theme.designerEdit.mainTitle.color};
  margin-bottom: 21px;

  ${({ fontSize }) =>
    css`
      font-size: ${fontSize};
    `};

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 51px;
    line-height: 60px;
  }

  @media (max-width: ${LayoutConst.screen.md}px) {
    font-size: 34px;
    line-height: 41px;
  }
`;

export const DocsSearchInputWrapper = styled(FlexBox)`
  background: ${(p) => p?.theme.tagSearch.background};
  border-radius: 3px;
  place-items: center;
  height: 48px;
  padding: 0 16px;
  svg {
    display: block;
  }

  input {
    border: none;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 129.412% */
    letter-spacing: -0.34px;
    padding-top: 0;
    padding-bottom: 0;
    -webkit-user-select: all;
    user-select: all;

    &::placeholder {
      color: ${({ theme }) => theme.tags.modal.search.color};
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: 40px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    border-radius: 3px;
    align-items: center;
    border: none;

    width: calc(100%);
    svg {
      width: 16px !important;
      height: 16px !important;
      margin-right: 8px;
      * {
        fill: ${(p) => p.theme.navigationBar.search.svg} !important;
      }
    }
  }
`;

export const DocNameInput = styled.input.attrs({ className: "--input" })`
  border: 1px solid ${({ theme }) => theme.tags.modal.search.color};
  border-radius: 3px;
  font-size: 15px;
  font-style: normal;
  font-weight: 200;
  line-height: 20px; /* 129.412% */
  letter-spacing: -0.34px;
  padding: 5px;
  margin-bottom: 10px;
  -webkit-user-select: all;
  user-select: all;

  &::placeholder {
    color: ${({ theme }) => theme.tags.modal.search.color};
  }
`;

export const DocsSearchInput = styled.input.attrs({ className: "--input" }) <{ isMobileInput?: boolean }>`
  ${Fonts.Inter.text};
  color: ${(p) => p.theme.tagSearch.inputColor} !important;
  width: 100%;
  height: 48px;
  background: ${(p) => (p?.isMobileInput ? p?.theme.tagSearch.background : "transparent")};
  border: none;
  border-bottom: 1px solid ${(p) => p.theme.tagSearch.inputColor};
  outline: none;
  font-size: 15px;
  line-height: 20px;

  padding: 14px 0px 14px 2px;

  ::placeholder {
    color: ${(p) => p.theme.tagSearch.inputColor};
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: 40px;
    font-size: 13px;
    line-height: 16px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    padding: 15px 16px 13px;
    border-bottom: none;

    height: initial;
    ::placeholder {
      color: ${Colors.galBlack47};
    }
  }
`;

export const TitleWrapper = styled(FlexBox)`
  width: 100%;
`;

export const DocTitle = styled.div`
  font-size: 18px;
  line-height: 22px;
  color: ${({ theme }) => theme.projectEdit.mobile.buttons.color};
  overflow: wrap;
  text-overflow: wrap;
  max-width: 500px;
  margin-right: 8px;
  cursor: pointer;
`;

export const DocText = styled(FlexBox)`
  margin-top: 7px;
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  color: ${({ theme }) => theme.projectEdit.label};
`;
export const DocTextCaption = styled(FlexBox)`
  margin-top: 10px;
  font-size: 15px;
  font-weight: 600;
  line-height: 18px;
  color: ${({ theme }) => theme.projectEdit.label};
`;

export const VersionsWrapper = styled(FlexBox)`
  margin-top: 16px;
  gap: 24px;
`

export const PrevVersion = styled(FlexBox)`
  width: 100%;
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.26px;
  color: ${({ theme }) => theme.projectEdit.label};
  a {
    text-decoration: underline !important;
    color: inherit;
  }
  &:nth-child(2) {
    font-weight: 600;
  }
`;

export const EditorButtons = styled(FlexBox)`
  margin: 2px;
  padding: 2px;
  width: fit-content;
  border: 1px solid gray;
  border-radius: 2px;
  flex-direction: row;
`;

export const EditorButton = styled(FlexBox)`
  margin: 2px;
  padding: 2px;
  width: fit-content;
  border: 1px solid gray;
  border-radius: 2px;
  cursor: pointer;
`;

export const TiptapContainer = styled(FlexBox)`
  width: 100%;
  overflow: visible;
  max-width: 1152px;
  margin: 32px auto 0;
  padding: 0 16px;
  flex-direction: column;
  padding-bottom: 120px;

  @media (max-width: ${LayoutConst.screen.md}px) {
    margin-top: 24px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    margin-top: 16px;
  }
`;

const h1headerStyles = css`
  font-size: 43px;
  font-style: normal;
  font-weight: 600;
  line-height: 51px; 
  letter-spacing: -0.86px;
  color: ${({ theme }) => theme.app.text};
  &:not(:first-child) {
    margin-top: 80px;
  } 
  margin-bottom: 24px;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 30px;
    line-height: 40px;
    letter-spacing: -0.6px;
    &:not(:first-child) {
      margin-top: 56px;
    }
  }

  @media (max-width: ${LayoutConst.screen.md}px) {
    font-size: 26px;
    line-height: 32px;
    letter-spacing: -0.54px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 20px;
    line-height: 25px;
    letter-spacing: -0.4px;
    &:not(:first-child) {
      margin-top: 48px;
    }
  }
`;

const h2headerStyles = css`
  font-size: 34px;
  font-style: normal;
  font-weight: 600;
  line-height: 41px;
  letter-spacing: -0.02em;
   &:not(:first-child) {
    margin-top: 80px;
  } 
  margin-bottom: 24px;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 26px;
    line-height: 32px;
    letter-spacing: -0.6px;
    &:not(:first-child) {
      margin-top: 56px;
    }
  }

  @media (max-width: ${LayoutConst.screen.md}px) {
     font-size: 23px;
    line-height: 27px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.4px;
    &:not(:first-child) {
      margin-top: 48px;
    }
  }
`;


const h3headerStyles = css`
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 25px;
  letter-spacing: -0.4px;
  margin-bottom: 16px;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.34px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 15px;
    line-height: 20px;
  }
`;

export const DocumentContent = styled.div`
  h1 {
    ${h1headerStyles};
  }

  h2 {
    ${h2headerStyles};
  }

  h1 strong,
  h2 strong,
  h1 b,
  h2 b {
    font-weight: inherit;
  }

  h3 { 
    ${h3headerStyles};
  }

  a {
    word-break: break-word;
  }

  p {
    font-size: 17px;
    font-weight: 400;
    line-height: 22px; 
    letter-spacing: -0.34px;
    margin-bottom: 32px;
  }

  ol, ul {
    padding-inline-start: 1.5em;
    margin-left: 0;
    li {
      margin-bottom: 16px;
      p {
        margin-bottom: 0;
      }
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px) {

    p {
      font-size: 15px;
      line-height: 20px;
      letter-spacing: -0.3px;
      margin-bottom: 24px;
    }
  }
`;

export const LegalBlocksNew = styled(LegalBlocks)`
  width: 100%;
  max-width: initial;
  padding: 0;
  margin: 0;
`;

export const LegalsHeader = styled.h1`
  ${h1headerStyles};
  margin-bottom: 32px;

  @media (max-width: ${LayoutConst.screen.md}px) {
    margin-bottom: 16px;
  }
`;

export const DocumentWrapper = styled(FlexBox)`
  width: 100%;
  align-items: flex-start;
  

  @media (max-width: ${LayoutConst.screen.s}px) {
    flex-direction: column;
  }
`;

export const LegalsSubHeader = styled.h3`
  ${h3headerStyles};
`;

export const VersionRow = styled(FlexBox)`
  gap: 8px 24px;
  width: 100%;
  margin-bottom: 16px;

  @media (max-width: ${LayoutConst.screen.md}px) {
    flex-direction: column;
  }
`;

export const BackButton = styled(FlexBox)`
  color: ${Colors.galBlack47};
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px; 
  align-items: center;
  gap: 4px;
  margin-bottom: 4px;
  cursor: pointer;
`;import { Colors, FInter, FlexBox, Fonts } from "@brg/ui";
import { TableCell } from "@tiptap/extension-table";
import { CoreContainer, LayoutConst } from "core";
import { SectionContent } from "shared/components/legals/styles";
import styled, { css } from "styled-components";
import { EditorContent } from "@tiptap/react";

const FOOTER_HEIGHT = 40;

export const StyledEditorContent = styled(EditorContent)`
  .ProseMirror {
    min-height: 180px;
    height: 800px;
    border: 1px solid ${(p) => p.theme.legals.textColor};
    padding: 5px;
    margin: 10px 0;
    border-radius: 3px;
    overflow-y: scroll;
    overflow-x: hidden;

    td {
      position: relative;
    }
    
    .column-resize-handle {
      position: absolute;
      top: 0;
      right: -2px;
      bottom: 0;
      width: 4px; 
      background: transparent;
      z-index: 10;
      cursor: col-resize !important;
    }
  
    .column-resize-handle:hover {
      background: rgba(0, 0, 0, 0.1);
    }
  }
`;

export const CustomTableCell = TableCell.extend({
  addAttributes() {
    return {
      ...this.parent?.(),

      borderStyle: {
        default: "2px solid #ced4da",
        parseHTML: (element) => element.style.borderStyle || "2px solid #ced4da",
        renderHTML: (attributes) => {
          return {
            style: `border: ${attributes.borderStyle}`,
          };
        },
      },
      backgroundColor: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-background-color"),
        renderHTML: (attributes) => {
          return {
            "data-background-color": attributes.backgroundColor,
            style: `background-color: ${attributes.backgroundColor}`,
          };
        },
      },
      style: {
        default: "height: 28px; padding: 3px 5px",
      },
    };
  },
});

export const LegalBlocks = styled.div`
  max-width: 890px;
  margin: 20px 0 60px 400px;
  color: ${(p) => p.theme.legals.textColor};
  @media (max-width: ${LayoutConst.screen.md}px) {
    margin-left: 0;
    padding: 40px 10px;
    ${SectionContent} {
      margin-left: 0;
    }
  }
`;

export const Routes = styled.div`
  width: 100%;
  font-size: 13.4px;
  line-height: 1.27em;
  margin-bottom: 60px;

  span:first-of-type {
    margin-right: 10px;
  }
`;

export const Tab = styled.div`
  position: sticky;
  top: 52px;
  width: 360px;
  box-sizing: border-box;
  height: max-content;
  align-self: flex-start;
  left: 20px;
  margin-right: 32px;
  margin-bottom: 32px;
  color: ${(p) => p.theme.legals.textColor};
  flex-shrink: 0;
  @media (max-width: ${LayoutConst.screen.md}px) {
    width: 220px;
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    width: 100%;
    border: none;
    position: static;
    height: min-content;
    z-index: 2;
    top: 48px;
    margin-right: 24px;
  }
`;
export const Arrow = styled.span`
  border-right: 2px solid;
  border-bottom: 2px solid;
  position: relative;
  bottom: 2px;
  display: inline-block;
  padding: 3px;
  transform: rotate(-45deg);
  margin-right: 10px;
  border-color: ${(p) => p.theme.legals.textColor};
`;

export const AdminPageDocumentList = styled(FlexBox)`
  width: 100%;
  flex-flow: column;
  margin: 0 auto;
  justify-content: center;
  place-items: center;
  background: #fff;
  padding: 24px 48px;
  max-width: 1152px;
`;

export const EditButtonWrapper = styled(FlexBox)`
  position: absolute;
  right: 0px;
  top: 0px;
`;

export const ArrowDown = styled(FlexBox) <{ isOpen: boolean }>`
  margin: 7px;
  transition: transform 0.2s;
  cursor: pointer;

  svg path {
    fill: #909090;
  }

  ${({ isOpen }) =>
    isOpen &&
    css`
      transform: rotate(180deg);
      transition: transform 0.2s;
    `};
`;

export const DeleteBtnWrapper = styled(FlexBox)`
  cursor: pointer;
  svg {
    overflow: visible;
  }
`;

export const AdminPageDocument = styled.div<{ isDraggable?: boolean }>`
  color: ${({ theme }) => theme.projectEdit.label};
  font-family: Inter;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.3px;

  ${({ isDraggable }) => isDraggable && css`
    display: flex;
    justify-content: space-between;
    place-items: center;

    // .divider {
    //   // margin-right: 16px;
    // }
  `};
`;

export const AdminEditContainer = styled(FlexBox)`
  justify-content: space-between;
  display: flex;
  margin-top: 60px;
  margin: 0 auto;
  flex-direction: column;
  width: 954px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 710px;
  }

  .white_theme_project_underline {
    font-size: 23px;
    line-height: 29px;

    @media (max-width: ${LayoutConst.screen.md}px) {
      font-size: 20px;
      line-height: 25px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      font-size: 15px;
      line-height: 20px;
    }
  }
`;

export const AdminScrollEditContainer = styled(AdminEditContainer)`
  margin: 0 auto ${FOOTER_HEIGHT}px auto;
`;

export const AdminInputGrid = styled(FlexBox) <{ marginTop?: number }>`
  flex-direction: column;

  ${({ marginTop }) =>
    marginTop
      ? css`
          margin-top: ${marginTop}px;
        `
      : null};
`;

export const AvailableAppsContainer = styled(FlexBox)`
  flex-direction: row;
  margin-top: 20px;
  flex-wrap: wrap;
  display: flex;
`;

export const SiteContextItem = styled(FlexBox) <{ isActive: boolean; isClickable: boolean }>`
  border: 1px solid;
  border-color: ${({ theme }) => theme.projectEdit.label};
  color: ${({ theme }) => theme.projectEdit.label};
  border-radius: 3px;
  margin: 5px;
  padding: 3px 7px;
  font-size: 13px;
  line-height: 18px;

  ${({ isClickable }) =>
    isClickable &&
    css`
      cursor: pointer;
    `};

  ${({ isActive }) =>
    isActive &&
    css`
      background-color: ${({ theme }) => theme.projectEdit.label};
      color: white;
    `};
`;

export const LegalDocumentAdminRow = styled(FlexBox) <{ gradientNeed?: boolean; blackBG?: boolean }>`
  position: relative;
  align-items: center;

  & + & {
    margin-top: 24px;
  }

  &:after {
    content: "";
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 2px;
    width: 97px;
    z-index: 2;
    height: 45px;
    background: ${(p) =>
    p?.blackBG
      ? "linear-gradient(270deg, rgba(197,198,199,0.9) 55% , rgba(197,198,199,0) 100%);"
      : "linear-gradient(270deg, rgba(242,242,242,0.9) 55.21%, rgba(242, 242, 242, 0) 100%);"};
    display: ${(p) => (p?.gradientNeed ? "inline-block" : "none")};
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    height: auto;
    & + & {
      margin-top: 16px;
    }
  }
`;

export const LegalDocumentsTitle = styled(FInter.MainTitleMedium) <{ fontSize: string }>`
  margin-top: 56px;
  font-weight: 600;
  padding-bottom: 11px;

  line-height: 70px;
  white-space: pre;
  color: ${(p) => p.theme.designerEdit.mainTitle.color};
  margin-bottom: 21px;

  ${({ fontSize }) =>
    css`
      font-size: ${fontSize};
    `};

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 51px;
    line-height: 60px;
  }

  @media (max-width: ${LayoutConst.screen.md}px) {
    font-size: 34px;
    line-height: 41px;
  }
`;

export const DocsSearchInputWrapper = styled(FlexBox)`
  background: ${(p) => p?.theme.tagSearch.background};
  border-radius: 3px;
  place-items: center;
  height: 48px;
  padding: 0 16px;
  svg {
    display: block;
  }

  input {
    border: none;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 129.412% */
    letter-spacing: -0.34px;
    padding-top: 0;
    padding-bottom: 0;
    -webkit-user-select: all;
    user-select: all;

    &::placeholder {
      color: ${({ theme }) => theme.tags.modal.search.color};
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: 40px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    border-radius: 3px;
    align-items: center;
    border: none;

    width: calc(100%);
    svg {
      width: 16px !important;
      height: 16px !important;
      margin-right: 8px;
      * {
        fill: ${(p) => p.theme.navigationBar.search.svg} !important;
      }
    }
  }
`;

export const DocNameInput = styled.input.attrs({ className: "--input" })`
  border: 1px solid ${({ theme }) => theme.tags.modal.search.color};
  border-radius: 3px;
  font-size: 15px;
  font-style: normal;
  font-weight: 200;
  line-height: 20px; /* 129.412% */
  letter-spacing: -0.34px;
  padding: 5px;
  margin-bottom: 10px;
  -webkit-user-select: all;
  user-select: all;

  &::placeholder {
    color: ${({ theme }) => theme.tags.modal.search.color};
  }
`;

export const DocsSearchInput = styled.input.attrs({ className: "--input" }) <{ isMobileInput?: boolean }>`
  ${Fonts.Inter.text};
  color: ${(p) => p.theme.tagSearch.inputColor} !important;
  width: 100%;
  height: 48px;
  background: ${(p) => (p?.isMobileInput ? p?.theme.tagSearch.background : "transparent")};
  border: none;
  border-bottom: 1px solid ${(p) => p.theme.tagSearch.inputColor};
  outline: none;
  font-size: 15px;
  line-height: 20px;

  padding: 14px 0px 14px 2px;

  ::placeholder {
    color: ${(p) => p.theme.tagSearch.inputColor};
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: 40px;
    font-size: 13px;
    line-height: 16px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    padding: 15px 16px 13px;
    border-bottom: none;

    height: initial;
    ::placeholder {
      color: ${Colors.galBlack47};
    }
  }
`;

export const TitleWrapper = styled(FlexBox)`
  width: 100%;
`;

export const DocTitle = styled.div`
  font-size: 18px;
  line-height: 22px;
  color: ${({ theme }) => theme.projectEdit.mobile.buttons.color};
  overflow: wrap;
  text-overflow: wrap;
  max-width: 500px;
  margin-right: 8px;
  cursor: pointer;
`;

export const DocText = styled(FlexBox)`
  margin-top: 7px;
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  color: ${({ theme }) => theme.projectEdit.label};
`;
export const DocTextCaption = styled(FlexBox)`
  margin-top: 10px;
  font-size: 15px;
  font-weight: 600;
  line-height: 18px;
  color: ${({ theme }) => theme.projectEdit.label};
`;

export const VersionsWrapper = styled(FlexBox)`
  margin-top: 16px;
  gap: 24px;
`

export const PrevVersion = styled(FlexBox)`
  width: 100%;
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.26px;
  color: ${({ theme }) => theme.projectEdit.label};
  a {
    text-decoration: underline !important;
    color: inherit;
  }
  &:nth-child(2) {
    font-weight: 600;
  }
`;

export const EditorButtons = styled(FlexBox)`
  margin: 2px;
  padding: 2px;
  width: fit-content;
  border: 1px solid gray;
  border-radius: 2px;
  flex-direction: row;
`;

export const EditorButton = styled(FlexBox)`
  margin: 2px;
  padding: 2px;
  width: fit-content;
  border: 1px solid gray;
  border-radius: 2px;
  cursor: pointer;
`;

export const TiptapContainer = styled(FlexBox)`
  width: 100%;
  overflow: visible;
  max-width: 1152px;
  margin: 32px auto 0;
  padding: 0 16px;
  flex-direction: column;
  padding-bottom: 120px;

  @media (max-width: ${LayoutConst.screen.md}px) {
    margin-top: 24px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    margin-top: 16px;
  }
`;

const h1headerStyles = css`
  font-size: 43px;
  font-style: normal;
  font-weight: 600;
  line-height: 51px; 
  letter-spacing: -0.86px;
  color: ${({ theme }) => theme.app.text};
  &:not(:first-child) {
    margin-top: 80px;
  } 
  margin-bottom: 24px;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 30px;
    line-height: 40px;
    letter-spacing: -0.6px;
    &:not(:first-child) {
      margin-top: 56px;
    }
  }

  @media (max-width: ${LayoutConst.screen.md}px) {
    font-size: 26px;
    line-height: 32px;
    letter-spacing: -0.54px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 20px;
    line-height: 25px;
    letter-spacing: -0.4px;
    &:not(:first-child) {
      margin-top: 48px;
    }
  }
`;

const h2headerStyles = css`
  font-size: 34px;
  font-style: normal;
  font-weight: 600;
  line-height: 41px;
  letter-spacing: -0.02em;
   &:not(:first-child) {
    margin-top: 80px;
  } 
  margin-bottom: 24px;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 26px;
    line-height: 32px;
    letter-spacing: -0.6px;
    &:not(:first-child) {
      margin-top: 56px;
    }
  }

  @media (max-width: ${LayoutConst.screen.md}px) {
     font-size: 23px;
    line-height: 27px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.4px;
    &:not(:first-child) {
      margin-top: 48px;
    }
  }
`;


const h3headerStyles = css`
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 25px;
  letter-spacing: -0.4px;
  margin-bottom: 16px;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.34px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 15px;
    line-height: 20px;
  }
`;

export const DocumentContent = styled.div`
  h1 {
    ${h1headerStyles};
  }

  h2 {
    ${h2headerStyles};
  }

  h1 strong,
  h2 strong,
  h1 b,
  h2 b {
    font-weight: inherit;
  }

  h3 { 
    ${h3headerStyles};
  }

  a {
    word-break: break-word;
  }

  p {
    font-size: 17px;
    font-weight: 400;
    line-height: 22px; 
    letter-spacing: -0.34px;
    margin-bottom: 32px;
  }

  ol, ul {
    padding-inline-start: 1.5em;
    margin-left: 0;
    li {
      margin-bottom: 16px;
      p {
        margin-bottom: 0;
      }
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px) {

    p {
      font-size: 15px;
      line-height: 20px;
      letter-spacing: -0.3px;
      margin-bottom: 24px;
    }
  }
`;

export const LegalBlocksNew = styled(LegalBlocks)`
  width: 100%;
  max-width: initial;
  padding: 0;
  margin: 0;
`;

export const LegalsHeader = styled.h1`
  ${h1headerStyles};
  margin-bottom: 32px;

  @media (max-width: ${LayoutConst.screen.md}px) {
    margin-bottom: 16px;
  }
`;

export const DocumentWrapper = styled(FlexBox)`
  width: 100%;
  align-items: flex-start;
  

  @media (max-width: ${LayoutConst.screen.s}px) {
    flex-direction: column;
  }
`;

export const LegalsSubHeader = styled.h3`
  ${h3headerStyles};
`;

export const VersionRow = styled(FlexBox)`
  gap: 8px 24px;
  width: 100%;
  margin-bottom: 16px;

  @media (max-width: ${LayoutConst.screen.md}px) {
    flex-direction: column;
  }
`;

export const BackButton = styled(FlexBox)`
  color: ${Colors.galBlack47};
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px; 
  align-items: center;
  gap: 4px;
  margin-bottom: 4px;
  cursor: pointer;
`;